import axios from "axios";
import {  message } from "antd";

const apiUrl = process.env.REACT_APP_API_URL;

export const get_users = async (token, type_value) => {
	try {
		const res = await axios.post(`${apiUrl}/get_users`, {
			token, type_value
		});
		if (res.status == 200) return res.data;

		else message.error(res.data);
		return [];
	} catch (err) {
		message.error(err.response.data);
		return [];
	}
};

export const edit_user = async (token, data, type_value) => {
	try {
		// Asegúrate de que `data` incluya `selectedOrganization`
		const res = await axios.post(`${apiUrl}/edit_user`, {
			token,
			type_value,
			data
		});
  
		if (res.status == 200) {
			message.success("Edited Correctly");
			return true;
		} else {
			if (res.data instanceof Array) {
				for (const error of res.data) {
					message.error(error);
				}
			}
		}
		return false;
	} catch (err) {
		if (err.response.data instanceof Array) {
			for (const error of err.response.data) {
				message.error(error);
			}
		} else {
			message.error(err.response.data);
		}
		return false;
	}
};
  
